import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id FEF8AC85-F9E6-4C9B-B0C2-A5158AAD8A8B
 * name home-remove
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-remove.svg
 * tags
 * - Home Automation 
 */
export const HomeRemoveIcon = createSvgIcon(<><path d="M14.46 15.88L15.88 14.46L18 16.59L20.12 14.47L21.54 15.88L19.41 18L21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.46 20.12L16.59 18L14.47 15.88M12 3L22 12H18C14.69 12 12 14.69 12 18C12 18.7 12.12 19.37 12.34 20H5V12H2L12 3Z" /></>, 'HomeRemoveIcon');
export default HomeRemoveIcon